import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowStretchBox32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowStretchBox32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 8h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2m-4 2a4 4 0 0 1 4-4h18a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4zm8.374 7 1.833 1.833a1 1 0 0 1-1.414 1.414l-3.536-3.535-.707-.707.707-.708 3.536-3.535a1 1 0 0 1 1.414 1.414L11.383 15h9.234l-1.824-1.824a1 1 0 0 1 1.414-1.414l3.536 3.535.707.707-.707.708-3.536 3.535a1 1 0 0 1-1.414-1.414L20.626 17z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowStretchBox32);
